export enum UIPattern {
  STANDARD = 'Standard Offer',
  STEPPER = 'Locked Offer Progress Bar',
  LIST = 'Locked Offer List',
  PROMO = 'Promo Code Offer',
  ERROR = 'Error Text'
}
